export namespace SHORTCUT_ACTION_TYPE {
    export const CREATE_CONTACT = "create-contact"
    export const CREATE_QUOTE = "create-quote"
    export const CREATE_INVOICE = "create-invoice"
    export const CREATE_ORDER = "create-order"
    export const CREATE_SUBSCRIPTION = "create-subscription"
    export const CREATE_APPOINTMENT = "create-appointment"
    export const CLONE_INVOICE = "clone-invoice"
    export const CLONE_QUOTE = "clone-quote"
    
}
  
export const getIconValue = (actionName: SHORTCUT_ACTION_TYPE) => {
    switch(actionName){
    case SHORTCUT_ACTION_TYPE.CREATE_CONTACT:
        return "users"
    case SHORTCUT_ACTION_TYPE.CREATE_QUOTE:
        return "quote"
    case SHORTCUT_ACTION_TYPE.CREATE_INVOICE:
        return "invoice"
    case SHORTCUT_ACTION_TYPE.CREATE_ORDER:
        return "order"
    case SHORTCUT_ACTION_TYPE.CREATE_SUBSCRIPTION:
        return  "sync-alt"
    case SHORTCUT_ACTION_TYPE.CREATE_APPOINTMENT:
        return "calendar-day"
    case SHORTCUT_ACTION_TYPE.CLONE_INVOICE: case SHORTCUT_ACTION_TYPE.CLONE_QUOTE:
        return "clone"
    default:
        return ""
    }
}

export type SHORTCUT_ACTION_TYPE = typeof SHORTCUT_ACTION_TYPE[keyof typeof SHORTCUT_ACTION_TYPE]


// WEBPACK FOOTER //
// ./src/state/shortcut/ShortcutAction.ts